// Temporary frontend sponsor: no database record or migration is required.
export const seequentSponsor = {
  id: 'static-seequent',
  slug: 'seequent',
  isStatic: true,
  name_ar: 'Seequent',
  name_en: 'Seequent',
  logo: '/assets/sponsors/seequent_logo.svg',
  banner: '/aidsmo_seequent_banner.mp4',
  banner_type: 'video',
  banner_url: 'https://www.seequent.com/products-solutions/mining/',
  website_url: 'https://www.seequent.com',
  email: 'support@seequent.com',
  x: 'https://x.com/seequentglobal',
  facebook: 'https://www.facebook.com/seequent.software/',
  youtube: 'https://www.youtube.com/@Seequent',
  linkedin: 'https://www.linkedin.com/company/seequent/',
  country: { name_ar: 'نيوزيلندا', name_en: 'New Zealand' },
  sponsor_package: { name_ar: 'الراعي الماسي', name_en: 'Diamond sponsor' },
  description_title_ar: 'نبذة عن الشركة',
  description_title_en: 'About the Company',
  description_en: `
    <div class="space-y-6 leading-8">
      <p><strong>Seequent</strong>, a <strong>Bentley Systems</strong> company, is a global leader in the development of software and solutions for subsurface science and <strong>3D Implicit Modelling</strong>. The company began its journey by developing its pioneering <strong>Leapfrog</strong> technology and commercially launching it in <strong>2003</strong>. It then expanded its innovation efforts by developing advanced software solutions that support fast, accurate, and sustainable decision-making for engineering and geological projects around the world.</p>
      <p><strong>Seequent</strong> software serves more than <strong>7,400</strong> customers in over <strong>145</strong> countries, and is relied upon by <strong>9</strong> of the world’s <strong>10</strong> largest mining companies. Its solutions cover four key sectors:</p>
      <ul class="list-inside list-disc space-y-4">
        <li><strong>Mining:</strong> Solutions for mineral exploration, dynamic geological modelling of deposits, resource estimation, and drillhole planning to improve production efficiency and sustainability.</li>
        <li><strong>Civil:</strong> Providing an accurate understanding of soil and rock layers and conditions to reduce geotechnical risks during the design and construction of tunnels, bridges, and major projects.</li>
        <li><strong>Environmental:</strong> Managing and monitoring groundwater resources, assessing and remediating contamination, and supporting proactive environmental decision-making to protect natural resources.</li>
        <li><strong>Energy:</strong> Accelerating the exploration and development of geothermal energy fields and enabling an effective transition towards clean energy.</li>
      </ul>
    </div>`,
  description_ar: `
    <div class="space-y-6 leading-8">
      <p>تعتبر <strong>سيكوانت (Seequent)</strong>، التابعة لمجموعة <strong>Bentley Systems</strong>، شركة عالمية رائدة في تطوير برمجيات وحلول علوم باطن الأرض والنمذجة الجيولوجية ثلاثية الأبعاد (<strong>3D Implicit Modelling</strong>). بدأت مسيرة الشركة بتطوير تقنية برنامج <strong>Leapfrog</strong> الرائد وإطلاقه تجارياً عام <strong>2003</strong>، لتتوسع بعد ذلك في ابتكار حلول برمجية متطورة تدعم اتخاذ القرارات السريعة والدقيقة والمستدامة للمشاريع الهندسية والجيولوجية حول العالم.</p>
      <p>تخدم برمجيات <strong>Seequent</strong> أكثر من <strong>7,400</strong> عميل في أكثر من <strong>145</strong> دولة، وتعتمد عليها <strong>9</strong> من أصل أكبر <strong>10</strong> شركات تعدين عالمية، وتغطي حلولها القطاعات الأربعة الأساسية:</p>
      <ul class="list-inside list-disc space-y-4">
        <li><strong>قطاع التعدين (Mining):</strong> حلول استكشاف المعادن، والنمذجة الجيولوجية الديناميكية للمكامن، وحساب الاحتياطيات وتخطيط آبار الحفر لرفع كفاءة الإنتاج والاستدامة.</li>
        <li><strong>الهندسة المدنية والبنية التحتية (Civil):</strong> توفير فهم دقيق لطبقات وظروف التربة والصخور لتقليل المخاطر الجيوتقنية أثناء تصميم وتشييد الأنفاق، الجسور، والمشاريع الكبرى.</li>
        <li><strong>البيئة والمياه الجوفية (Environmental):</strong> إدارة ومراقبة موارد المياه الجوفية، تقييم ومعالجة التلوث، ودعم اتخاذ القرارات البيئية الاستباقية لحماية الموارد الطبيعية.</li>
        <li><strong>الطاقة (Energy):</strong> تسريع استكشاف وتطوير حقول الطاقة الحرارية الأرضية (Geothermal Energy) وتمكين التحول الفعّال نحو الطاقة النظيفة.</li>
      </ul>
    </div>`,
}

export function withStaticSponsors(types) {
  const diamond = types?.diamond
  const sponsors = diamond?.sponsors ?? []
  // Keep the same presentation order for the banners and homepage logos.
  const priority = {
    seequent: 0,
    jordan_phosphate_mines_company: 1,
    'shrk-mnagm-alfosfat-alardny-almsahm-alaaam-almhdod': 1,
    fujairah_natural_resources_corporation: 2,
  }
  // Avoid a duplicate if Seequent is subsequently added to the database.
  const orderedSponsors = sponsors.some((sponsor) => sponsor.slug === seequentSponsor.slug)
    ? [...sponsors]
    : [seequentSponsor, ...sponsors]
  orderedSponsors.sort((a, b) => (priority[a.slug] ?? 3) - (priority[b.slug] ?? 3))
  return {
    ...types,
    diamond: {
      name_ar: 'الرعاة الماسيون',
      name_en: 'Diamond sponsors',
      ...diamond,
      have_sponsors: true,
      sponsors: orderedSponsors,
    },
  }
}

export function sponsorAssetUrl(sponsor, asset) {
  return sponsor.isStatic ? sponsor[asset] : `${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor[asset]}`
}
